module.exports = __webpack_public_path__ + "static/media/30.3e86c0b8.mp3";